@use "sass:map";
@use '../../sass/theme';
@use '../../sass/form-control-mixins';

:host {
  z-index: 9999;
}

.tooltip {
  display: none;
  background-color: var(--jui-tooltip-color-bg);
  color: var(--jui-tooltip-color);
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 9999;

  &__visible {
    display: inline-block;
    position: absolute;
  }

  &::after {
    content: "";
    position: absolute;
    transform: rotate(45deg);
    background-color: var(--jui-tooltip-color-bg);
  }

  &__left {
    bottom: unset;
    right: 50px;
    left: unset;
  }

  &__left__bottom {
    right: 30px;
    top: 45px;
    bottom: unset;
    left: unset;
  }
}

